var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"dot",class:_vm.state_text.class}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.state_text.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }